module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp123_6005.ccff86a8.png";